import { render, staticRenderFns } from "./tan_caseother.vue?vue&type=template&id=0683c102&scoped=true"
import script from "./tan_caseother.vue?vue&type=script&lang=js"
export * from "./tan_caseother.vue?vue&type=script&lang=js"
import style0 from "./tan_caseother.vue?vue&type=style&index=0&id=0683c102&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0683c102",
  null
  
)

export default component.exports